import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-between gap-2 flex-wrap" };
const _hoisted_2 = { class: "flex justify-start gap-2 flex-wrap" };
const _hoisted_3 = { class: "flex justify-end items-center gap-3" };
import { computed, onMounted } from "vue";
import { useDebounceFn } from "@vueuse/core";
import { useStore } from "vuex";
import DailyDateRangeSelector from "@/components/ui/date-range/overview/DailyDateRangeSelector.vue";
import { $tf } from "@/plugins/i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeOffTreeTableHeader',
    props: {
        selectedDay: {},
        initialSelectedDay: {},
        dayRangeLength: {},
        filters: {}
    },
    emits: ["update:selectedDay", "update:filters"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const debouncedSearch = useDebounceFn((value) => {
            const updatedFilters = { ...props.filters, query: value.target.value };
            emit("update:filters", updatedFilters);
        }, 500);
        const teams = computed(() => store.getters["census_team/teams"]);
        const teamFilterOptions = computed(() => {
            return teams.value.map((t) => ({
                label: t.name,
                value: t.id,
            }));
        });
        const onTimeOffFilterOptions = computed(() => {
            return [
                {
                    label: $tf("timeManagementOverview.filterByOnTimeOff.onTimeOff|Szabadságon"),
                    value: true,
                },
                {
                    label: $tf("timeManagementOverview.filterByOnTimeOff.offTimeOff|Nincs szabadságon"),
                    value: false,
                },
            ];
        });
        onMounted(() => {
            store.dispatch("census_team/fetchTeams");
        });
        return (_ctx, _cache) => {
            const _component_InputIcon = _resolveComponent("InputIcon");
            const _component_InputText = _resolveComponent("InputText");
            const _component_IconField = _resolveComponent("IconField");
            const _component_MultiSelect = _resolveComponent("MultiSelect");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_IconField, { class: "!shadow-none" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_InputIcon, null, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                            _createElementVNode("i", { class: "pi pi-search text-surface-400 !text-[0.765rem]" }, null, -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_InputText, {
                                    class: "border !border-surface-100 !bg-surface-0 !py-1.5 !pl-8 !shadow-none",
                                    placeholder: _unref($tf)('timeManagementOverview.filterByComment.placeholder|Szűrés komment alapján'),
                                    onInput: _unref(debouncedSearch)
                                }, null, 8, ["placeholder", "onInput"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_MultiSelect, {
                            "model-value": __props.filters.team,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] =
                                (value) => emit('update:filters', { ...__props.filters, team: value })),
                            options: teamFilterOptions.value,
                            "option-label": "label",
                            "option-value": "value",
                            placeholder: _unref($tf)('timeManagementOverview.filterByTeam.placeholder|Csapat'),
                            "max-selected-labels": 2,
                            "dropdown-icon": "pi pi-plus-circle",
                            filter: "",
                            "filter-placeholder": _unref($tf)('timeManagementOverview.filterByTeam.filterPlaceholder|Szűrés csapat alapján')
                        }, {
                            option: _withCtx(({ option }) => [
                                _createTextVNode(_toDisplayString(_unref($tf)(option.label)), 1)
                            ]),
                            _: 1
                        }, 8, ["model-value", "options", "placeholder", "filter-placeholder"]),
                        _createVNode(_component_MultiSelect, {
                            "model-value": __props.filters.onTimeOff,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                (value) => emit('update:filters', { ...__props.filters, onTimeOff: value })),
                            options: onTimeOffFilterOptions.value,
                            "option-label": "label",
                            "option-value": "value",
                            placeholder: _unref($tf)('timeManagementOverview.filterByOnTimeOff.placeholder|Szabadságon'),
                            "max-selected-labels": 1,
                            selectionLimit: 1,
                            "dropdown-icon": "pi pi-plus-circle"
                        }, {
                            option: _withCtx(({ option }) => [
                                _createTextVNode(_toDisplayString(option.label), 1)
                            ]),
                            _: 1
                        }, 8, ["model-value", "options", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(DailyDateRangeSelector, {
                            "selected-day": __props.selectedDay,
                            "initial-selected-day": __props.initialSelectedDay,
                            "day-range-length": __props.dayRangeLength,
                            "onUpdate:selectedDay": _cache[2] || (_cache[2] = (value) => emit('update:selectedDay', value))
                        }, null, 8, ["selected-day", "initial-selected-day", "day-range-length"])
                    ])
                ])
            ]));
        };
    }
});
